/**
 * Generated bundle index. Do not edit.
 */

export {IkImageComponent,IkUploadComponent,ImagekitioAngularModule} from './public_api';

export {ImageKitConfiguration as ɵa,ImagekitService as ɵb} from './imagekitio-angular/imagekit.service';